import React from 'react'
import { createBrowserRouter } from 'react-router-dom'
import BillsReports from './pages/BillingReport'
import Bills from './pages/Bills'
import CostExplorer from './pages/CostExplorer'
import CostExplorerReports from './pages/CostExplorerReports'
import Root from './pages/Root'
import Main from './pages/layout/Main'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
  },
  {
    element: <Main />,
    children: [
      {
        path: '/bills',
        element: <Bills />,
      },
      {
        path: '/billing-report',
        element: <BillsReports />,
      },
      {
        path: '/cost-explorer',
        element: <CostExplorer />,
      },
      {
        path: '/cost-explorer-reports',
        element: <CostExplorerReports />,
      },
    ],
  },
  {
    path: '*',
    element: <Root />,
  },
])

export default router
